import React from 'react';

export const ModalBody = ({ children }) => {
    return (
        <>
            <div className="modal-body">
                {children}
            </div>
        </>
    );
};
